export default function Overlay() {
  return (
    <div className='overlay'>
      By{' '}
      <a href='https://twitter.com/houm_kn' target='_blank'>
        @houm_kn
      </a>
      <br />
      Model made in Blender 3.0 and imported using{' '}
      <a href='https://docs.pmnd.rs/react-three-fiber/getting-started/introduction' target='_blank'>
        React Three Fiber
      </a>
    </div>
  )
}
